module.exports = __webpack_public_path__ + "assets/b12.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b12.png
// module id = 592
// module chunks = 0